import styled from 'styled-components'

export const ImagePromotion = styled.img`
  width: 4rem;
  height: 4rem;
  display: flex;
`
